var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "inherit"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M4.333 10.833v0a1.257 1.257 0 0 1-1.091-1.88l2.337-4.09c.335-.588.503-.882.739-1.095a2 2 0 0 1 .722-.42c.303-.098.64-.098 1.317-.098h9.286c.676 0 1.014 0 1.317.099a2 2 0 0 1 .722.419c.236.214.404.507.74 1.094l2.336 4.09a1.257 1.257 0 0 1-1.091 1.881v0m-17.334 0v8.717c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h10.934c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-8.717m-17.334 0h17.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.917 18.417v-3.25l2.708 1.625z"
  })));
};
export default SvgHome;